import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InvestorType } from "../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { getISTPaymentAmount, hasCashTransfer, hasSinglePayments } from "../../../../Shared/IST/Components/Shared/Utils";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../Actions/Action";
import { Contents } from "../../../Resoures/Contents";
import { AccountRoleStore, ClientAccountStore, TreasuredAssetsStore } from "../../../Stroes/Variable";
import { Urls } from "../../../Urls";
import { DocumentsAndDeclarations } from "../Common/Documents/Components/DocumentsAndDeclarations";
import { ClientNameHelper } from "../Common/Helpers/ClientNameHelper";
import { SubAccountTypeHelper } from "../Common/Helpers/SubAccountTypeHelper";
import { processTypeEnum, TransferInModelMap, TransferKeysMap } from "../Common/Resource/Contents";
import { isJointOrTrustAccount } from "../NewBusinessWizard/Components/WrapperSelection/WrapperSelctionHelper";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { SPTAction } from "./Actions/SPTActions";
import { AdviserCharges } from "./Components/AdviserCharges/AdviserCharges";
import { InvestmentSelectionTool } from "./Components/IST/IST";
import { PaymentsIn } from "./Components/PaymentsIn/PaymentsIn";
import { Review } from "./Components/Review/Review";
import { productMap, sptSteppersMap } from "./Resource/Content";
import { SPTInstructionStore } from "./Store/Variable";
import { QuoteErrors } from "../../../../../Wrap/Validation/Errors/Quote/QuoteErrors";
import { OrderType } from "../../../../../Wrap/Constants/Enums/Domain/OrderType";
import { SourceType } from "../../../../../Wrap/Constants/Enums/Domain/SourceType";

interface ISinglePaymentTransferWizardState extends IAccountContextWizardComponentState {
    extraInfo: {
        hasCashIsa: boolean;
        treasuredAssetProductIds: number[];
        treasuredAssetsInstructionId: number;
    };
}
export class SinglePaymentTransferWizard extends AccountContextWizardComponent<ISinglePaymentTransferWizardState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: {
                hasCashIsa: false,
                treasuredAssetProductIds: null,
                treasuredAssetsInstructionId: null,
            },
            orderType: OrderType.Percentage,
        };
    }
    constructor(props: any) {
        super(props);
        this.subscribeToStore(SPTInstructionStore, () => this.onInstructionStoreChange());
    }

    private onInstructionStoreChange() {
        if (SPTInstructionStore.getActionType() == ActionType.Success) {
            let data = SPTInstructionStore.getData();
            if (data.Contribution?.PreRetirementInstrumentSelections?.Instruments?.length > 0) {
                data = this.syncAllocation(data);
            }
            this.setState({
                isLoading: false,
                data: data,
                active: data?.Status === InstructionStatus.Pending || data?.Status === InstructionStatus.NotSpecified,
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentDidUpdate() {
        const { customer, clientAccount, data } = this.state;
        if (customer && clientAccount && !data) {
            const id = getQueryParameters()["id"];
            const params = getQueryParameters();
            const type = Number(getQueryParameters()["type"]);
            const subAccountHierarchyId = params["subaccounthierarchyid"];
            SPTAction.getInstruction(id, type, clientAccount.HierarchyId, subAccountHierarchyId, customer.CustomerId);
        }
    }

    onClientAccountStoreChange(): void {
        super.onClientAccountStoreChange();
        const { clientAccount } = this.state;
        if (clientAccount != null) {
            if (clientAccount.SubAccounts.some((ele) => ele.SubAccountType == SubAccountType.CashIsa)) {
                const extraInfo = this.state.extraInfo;
                extraInfo.hasCashIsa = true;
                this.setState({ extraInfo: extraInfo });
            }
            if (!clientAccount.SubAccounts.some((x) => x.SubAccountType == SubAccountType.WrapCash)) {
                const _date = JsonDateParser.getFormatDateString(new Date(), "yyyy/MM/dd") as any;
                Action.getProductsValuationDetailSummary(clientAccount.HierarchyId, null, _date);
            }
        }
    }

    saveInstruction(from, to, toUrl, params, stepLength) {
        if (from == stepLength - 1) { return this.onExit(); }

        if (!params["id"]) {
            params["id"] = this.state.data.HierarchyId;
            SPTAction.postInstructionProcess(
                HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId,
                ProcessType.AddSinglePaymentorTransfer
            );
        }
        const { customer } = this.state;

        const dataAux = { ...this.state.data };
        dataAux.Contribution.ClientRegularPayment = null;
        this.setState({ data: dataAux });

        SPTAction.saveInstruction(from, this.state.data, parseInt(params["type"]), customer?.CustomerId, (result) => {
            this.setState({ onPosting: false });
            const resultExclusion = result?.Errors?.filter(
                (x) => x?.ErrorCode != QuoteErrors.DirectDebitCanNotBeChangedBecauseLastAutoLineIsNotCompleted
            );
            if (resultExclusion?.length > 0) {
                this.setState({
                    errorMsg: resultExclusion.map((y) => y.UserMessage),
                    isShowErrorMsg: true,
                });
            } else {
                if (this.state.extraInfo.treasuredAssetsInstructionId) {
                    Action.setInstructionTreasuredAssetsProductIds(
                        this.state.extraInfo.treasuredAssetsInstructionId,
                        this.state.extraInfo.treasuredAssetProductIds,
                        () => {
                            this.setState({ onPosting: false });
                            this.navigate(to, toUrl, params);
                        }
                    );
                } else {
                    this.setState({ onPosting: false });
                    this.navigate(to, toUrl, params);
                }
            }
        });
    }

    private navigate(to, toUrl, params) {
        if (to == -1) {
            this.onExit();
        } else {
            Navigator.navigateTo(toUrl, {
                queryParamsObject: params,
                scrollAfterNavigating: true,
            });
        }
    }

    private getTotalSinglePaymentAmount(data) {
        return ((data?.ClientSinglePayment?.TaxRelief ? 1.25 : 1) * data?.ClientSinglePayment?.Money?.Amount || 0) +
            ((data?.ThirdPartySinglePayment?.TaxRelief ? 1.25 : 1) * data?.ThirdPartySinglePayment?.Money?.Amount || 0) +
            ((data?.EmployerSinglePayment?.TaxRelief ? 1.25 : 1) * data?.EmployerSinglePayment?.Money?.Amount || 0) +
            ((data?.EmployerSalaryDeductionSinglePayment?.TaxRelief ? 1.25 : 1) * data?.EmployerSalaryDeductionSinglePayment?.Money?.Amount || 0);
    }

    private getIacAmount(data, totalPaymentAmount) {
        if (data?.InitialAdviserCharge?.SourceType == SourceType.ProductCash) {
            return data?.InitialAdviserCharge?.Money?.Amount ||
                data?.InitialAdviserCharge?.Percentage * totalPaymentAmount / 100 ||
                0;
        }
        return 0;
    }

    private syncAllocation(data) {
        const totalPaymentAmount = this.getTotalSinglePaymentAmount(data?.Contribution);
        const iacAmount = this.getIacAmount(data?.Contribution, totalPaymentAmount);
    
        data.Contribution.PreRetirementInstrumentSelections.Instruments.forEach((ele, index) => {
            if (ele?.Single?.Money) {
                data.Contribution.PreRetirementInstrumentSelections.Instruments[index].Single.Money.Amount =
                    ele.Single.Percentage * (totalPaymentAmount - iacAmount) / 100;
            }
        });
    
        return data;
    }    

    onCancel() {
        // SPTAction.deleteInstruction(this.state.data.HierarchyId, () => this.onExit());
        //SLP-70599
        this.onExit();
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        SPTAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId,
            Number(getQueryParameters()["type"]),
            () => {
                this.setState({ isSubmitting: false });
                const params = getQueryParameters();
                const instructionId = HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId;
                SPTAction.cancelCommissionCharges(
                    instructionId,
                    params["hierarchyid"],
                    params["subaccounthierarchyid"],
                    this.state.data.Contribution.CancelAllCommissionCharges != null
                        ? this.state.data.Contribution.CancelAllCommissionCharges
                        : false
                );
            }
        );
    }

    onTreasuredAssetsStoreChange() {
        const treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();
        this.setState({
            extraInfo: {
                hasCashIsa: this.state.extraInfo.hasCashIsa,
                treasuredAssetProductIds: treasuredAssetProductIds,
                treasuredAssetsInstructionId: null,
            },
        });
    }

    onChangeTreasuredAssets(hierarchyId: string, productId: number, value: boolean) {
        let productIds = this.state.extraInfo.treasuredAssetProductIds;
        if (value) {
            productIds.push(productId);
        } else {
            productIds = productIds.filter((id) => id !== productId);
        }
        this.setState({
            extraInfo: {
                hasCashIsa: this.state.extraInfo.hasCashIsa,
                treasuredAssetProductIds: productIds,
                treasuredAssetsInstructionId: HierarchyIdHelper.generateHierarchyId(hierarchyId).entityId,
            },
        });
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    private setReviewConfirmSteppers() {
        const type = Number(getQueryParameters()["type"]);
        const { customer, data } = this.state;
        const len = this.stepperConfig.length;
        return [
            {
                title: sptSteppersMap.review,
                url: Urls.get().SPTreview,
                path: Contents.URLMap.review,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                needPrint: true,
                component: <Review {...this.getStepProps(len)} type={type} />,
            },
            {
                title: sptSteppersMap.doc,
                url: Urls.get().SPTdoc,
                path: Contents.URLMap.documentAndDeclarations,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[this.stepperConfig.length - 2].isValid(),
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <DocumentsAndDeclarations
                        {...this.getStepProps(len + 1)}
                        processType={processTypeEnum.SinglePaymentTransfer}
                        clAccountId={this.state.clientAccount?.HeadClAccountId}
                        isJointOrTrust={isJointOrTrustAccount(this.state.clientAccount?.InvestorType)}
                        subAccountType={type}
                        customerId={customer.CustomerId}
                    />
                ),
            },
            {
                title: sptSteppersMap.comfirm,
                url: Urls.get().SPTconfirm,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We have received your instruction to setup a single payment for ${data?.ClientDetails?.FirstName} ${data?.ClientDetails?.LastName} (${this.state.clientAccount?.HeadClAccountId})`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const subaccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const { Contribution } = this.state.data;
        const steppers = [
            {
                title: sptSteppersMap.paymentsIn,
                url: Urls.get().SPTPaymentsIn,
                path: Contents.URLMap.paymentIn,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <PaymentsIn {...this.getStepProps(0)} type={type} hasCashIsa={this.state.extraInfo.hasCashIsa} subaccountHierarchyId={subaccountHierarchyId} />
                ),
            },
        ];
        if (!SubAccountTypeHelper.isCashAccount(type)) {
            steppers.push({
                title: sptSteppersMap.adviserCharges,
                url: Urls.get().SPTAdviserCharge,
                path: Contents.URLMap.adviserCharges,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <AdviserCharges {...this.getStepProps(1)} type={type} />,
            });
            if (hasSinglePayments(Contribution) || hasCashTransfer(Contribution[TransferInModelMap[type]])) {
                steppers.push({
                    title: sptSteppersMap.investment,
                    url: Urls.get().SPTist,
                    path: Contents.URLMap.ist,
                    onStepLeave: (from, to) => {
                        this.onStepperLeave(from, to);
                    },
                    component: (
                        <InvestmentSelectionTool
                            {...this.getStepProps(2)}
                            type={type}
                            treasuredAssetProductIds={this.state.extraInfo.treasuredAssetProductIds}
                            onTreasuredAssetsStoreChange={() => this.onTreasuredAssetsStoreChange()}
                            onChangeTreasuredAssets={(subAccountInstructionId, productId, value) => {
                                this.onChangeTreasuredAssets(subAccountInstructionId, productId, value);
                            }}
                            orderType={this.state.orderType}
                            onOrderTypeChange={(value) => this.setState({ orderType: value })}
                        />
                    ),
                });
            }
        }

        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    getAccountHolder;

    setProcessProps() {
        const { data } = this.state;
        const type = Number(getQueryParameters()["type"]);
        const processProps = super.setProcessProps();
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: ClientNameHelper.clientNameDisplay(data?.ClientDetails, data?.SecondClientDetails),
            splitHeaderSub: this.state.clientAccount?.HeadClAccountId,
        };
        processProps.processTitle = "Single payment / transfer";
        processProps.subTitle = productMap[type];
        return processProps;
    }
}
